<template>
  <el-dialog class="dialog-goods-container" :close-on-click-modal="false" @close="handleClose" title="新增设置" :visible.sync="dialogVisible">
    <div class="v-goods" v-loading="loading" v-if="dialogVisible">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
        <el-form-item label="优惠劵名称" prop="coupon_name">
          <el-input v-model="ruleForm.coupon_name"></el-input>
        </el-form-item>
        <el-form-item label="优惠劵有效期(天)" prop="coupon_expire">
          <el-input type="number" min="0" v-model="ruleForm.coupon_expire"></el-input>
        </el-form-item>
        <el-form-item label="优惠劵描述" prop="coupon_description">
          <el-input type="textarea" :rows="6" v-model="ruleForm.coupon_description"></el-input>
        </el-form-item>
        <el-form-item label="目标群体" prop="target">
          <el-select v-model="ruleForm.target" placeholder="请选择目标群体" style="width:100%">
            <el-option label="死粉" value="1"></el-option>
            <el-option label="中粉" value="2"></el-option>
            <el-option label="活粉" value="3"></el-option>
            <el-option label="忠粉" value="4"></el-option>
            <el-option label="普粉" value="5"></el-option>
            <el-option label="全部" value="11"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="每个用户发劵数量" prop="couponcount">
          <el-input type="number" min="0" v-model="ruleForm.couponcount"></el-input>
        </el-form-item>
<!--        <el-form-item label="排序">
          <el-input type="number" v-model="ruleForm.listorder"></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { addRechargeCouponItem } from '@/views/webpc/MemberManagement/SendCouponList/apis'
export default {
  data () {
    return {
      loading: false,
      dialogVisible: false,
      CouponItemInfo: null,
      ruleForm: {
        coupon_name: '',
        coupon_description: '',
        coupon_expire: '',
        target: '',
        couponcount: ''
      },
      rules: {
        coupon_name: [{ required: true, message: '请输入优惠劵名称', trigger: 'blur' }],
        coupon_expire: [{ required: true, message: '请输入优惠劵有效期', trigger: 'blur' }],
        target: [{ required: true, message: '请选择目标群体', trigger: 'change' }],
        couponcount: [{ required: true, message: '请输入每个用户发劵数量', trigger: 'blur' }]
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm('发送后将无法撤销, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.getCoupon()
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
        } else {
          return false
        }
      })
    },
    async getCoupon () {
      this.loading = true
      let data = new FormData()
      data.append('coupon_name', this.ruleForm.coupon_name)
      data.append('coupon_description', this.ruleForm.coupon_description)
      data.append('coupon_expire', this.ruleForm.coupon_expire)
      data.append('target', this.ruleForm.target)
      data.append('couponcount', this.ruleForm.couponcount)
      addRechargeCouponItem(data)
        .then((result) => {
          if (result) {
            this.loading = false
            this.$message({
              type: 'success',
              message: '保存成功!'
            })
            this.$emit('ok')
            this.dialogVisible = false
          }
        })
        .catch((error) => {
          if (error) {
            this.loading = false
            this.$message({
              type: 'error',
              message: '保存失败!'
            })
          }
        })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    show (obj) {
      if (obj) {
        this.CouponItemInfo = obj
        this.ruleForm.coupon_name = obj.coupon_name
        this.ruleForm.coupon_description = obj.coupon_description
        this.ruleForm.coupon_expire = obj.coupon_expire
        this.ruleForm.target = obj.target
        this.ruleForm.couponcount = obj.couponcount
      } else {
        this.CouponItemInfo = ''
        this.ruleForm.coupon_name = ''
        this.ruleForm.coupon_description = ''
        this.ruleForm.coupon_expire = ''
        this.ruleForm.target = ''
        this.ruleForm.couponcount = ''
      }
      this.dialogVisible = true
    },
    handleClose () {
      setTimeout(() => {
        this.CouponItemInfo = null
      }, 200)
      this.dialogVisible = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/webpc/MemberManagement/SendCouponList/modules/RechargeCouponModal.vue